function cov_n5yu6b9tx() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/PhotoLibrary.tsx";
  var hash = "ae3b002eaac023a31b3d61b3fd45eb2df87b6575";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/PhotoLibrary.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ae3b002eaac023a31b3d61b3fd45eb2df87b6575"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_n5yu6b9tx = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_n5yu6b9tx();
var Icon = (cov_n5yu6b9tx().s[0]++, {
  name: 'photo-library',
  svg: "<path d=\"M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z\" fill=\"currentColor\"/>"
});
export default Icon;